// removed by extract-text-webpack-plugin
module.exports = {"wolf":"#dcdee2","polarBear":"#f2f3f5","this":"GroupView__this___1ti-r","loading":"GroupView__loading___2-2bQ","wrapper":"GroupView__wrapper___3JCio","topBorder":"GroupView__topBorder___Gz-Nz","nuxTopBorder":"GroupView__nuxTopBorder___2sFlu"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupView.css
// module id = 2558
// module chunks = 0 1